module.exports = __webpack_public_path__ + "img/exclusive_04.406326cb.jpg";